<template>
  <div>
    <b-container>
      <b-card title="Login" class="col-lg-8 offset-lg-2 col-xl-4 offset-xl-4">
        <b-form @submit.prevent="login">
          <b-form-group label="Email" label-for="email">
            <b-form-input
              id="email"
              name="email"
              type="email"
              placeholder="example@example.com"
              autocomplete="email"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Password" label-for="password">
            <b-form-input
              id="password"
              name="password"
              type="password"
              autocomplete="current-password"
              required
            ></b-form-input>
            <router-link to="/accounts/password/reset/">Forget It?</router-link>
          </b-form-group>
          <hr />
          <div class="submit-button-group">
            <b-button type="submit" variant="primary">Login</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { gup, safeRedirect } from "../utils";

export default Vue.component("signup", {
  data() {
    return {};
  },
  methods: {
    async login(event) {
      const form = event.target;
      const data = new FormData(form);

      try {
        await axios.post("/accounts/login/", data);
        window.location = safeRedirect(gup("redirect", window.location));
      } catch (e) {
        alert("아이디 또는 비밀번호를 확인해주세요.");
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.submit-button-group {
  display: flex;
  flex-direction: row-reverse;
}
</style>
